import { useEffect } from 'react';
import './LegalModal.css';

const impressumContent = (
  <>
    <p className="legal__intro">
      Die Rocaille GmbH betreibt in Düsseldorf ein Restaurant mit Bistro, Weinbar und Patisserie,
      das sich auf französische und internationale Küche spezialisiert hat.
    </p>

    <h3 className="legal__subtitle">Angaben gemäß § 5 DDG</h3>
    <p className="legal__text">
      Rocaille GmbH<br />
      Weißenburgstraße 19<br />
      40476 Düsseldorf<br />
      Deutschland
    </p>
    <p className="legal__text">
      Vertreten durch den Geschäftsführer: Alexandra Wende
    </p>
    <p className="legal__text">
      Telefon: <a href="tel:+4921197711737" className="legal__link">+49 (0) 211 97711737</a><br />
      E-Mail: <a href="mailto:genuss@rocaille.de" className="legal__link">genuss@rocaille.de</a>
    </p>

    <h3 className="legal__subtitle">Registereintrag</h3>
    <p className="legal__text">
      Eintragung im Handelsregister.<br />
      Registergericht: Amtsgericht Düsseldorf<br />
      Registernummer: HRB 79905
    </p>

    <h3 className="legal__subtitle">Umsatzsteuer-ID</h3>
    <p className="legal__text">
      Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
      DE310692238
    </p>

    <h3 className="legal__subtitle">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h3>
    <p className="legal__text">
      Michael Spreckelmeyer<br />
      Weißenburgstraße 19, 40476 Düsseldorf
    </p>

    <h3 className="legal__subtitle">EU-Streitschlichtung</h3>
    <p className="legal__text">
      Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
      <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="legal__link">
        https://ec.europa.eu/consumers/odr/
      </a>.<br />
      Unsere E-Mail-Adresse finden Sie oben im Impressum.
    </p>

    <h3 className="legal__subtitle">Verbraucherstreitbeilegung</h3>
    <p className="legal__text">
      Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.
    </p>
  </>
);

const datenschutzContent = (
  <>
    <p className="legal__meta">Stand: 01. August 2025</p>

    <h3 className="legal__subtitle">1. Datenschutz auf einen Blick</h3>
    <h4 className="legal__h4">Allgemeine Hinweise</h4>
    <p className="legal__text">
      Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen
      Daten geschieht, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit
      denen Sie persönlich identifiziert werden können.
    </p>

    <h4 className="legal__h4">Datenerfassung auf dieser Website</h4>
    <p className="legal__text">
      Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
      können Sie dem Impressum dieser Website entnehmen.
    </p>
    <p className="legal__text">
      Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen (z. B. Kontaktformular).
      Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website erfasst –
      vor allem technische Daten sowie Daten durch Cookies und Analysedienste. Die Erfassung dieser
      zustimmungspflichtigen Daten startet erst nach Ihrer Einwilligung.
    </p>
    <p className="legal__text">
      Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck
      Ihrer gespeicherten personenbezogenen Daten sowie ein Recht auf Berichtigung oder Löschung.
      Erteilte Einwilligungen können Sie jederzeit widerrufen.
    </p>

    <h3 className="legal__subtitle">2. Hosting</h3>
    <p className="legal__text">
      Wir hosten unsere Website bei Vercel Inc., 440 N Barranca Ave #4133, Covina, CA 91723, USA.
      Details:{' '}
      <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="legal__link">
        vercel.com/legal/privacy-policy
      </a>
    </p>
    <p className="legal__text">
      Die Verwendung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben einen Vertrag
      zur Auftragsverarbeitung (AVV) mit dem Anbieter geschlossen.
    </p>

    <h3 className="legal__subtitle">3. Allgemeine Hinweise und Pflichtinformationen</h3>
    <p className="legal__text">
      Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln
      Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften.
    </p>
    <p className="legal__text">
      <strong>Verantwortliche Stelle:</strong><br />
      Rocaille GmbH, Weißenburgstraße 19, 40476 Düsseldorf<br />
      Telefon: <a href="tel:+4921197711737" className="legal__link">+49 (0) 211 97711737</a><br />
      E-Mail: <a href="mailto:genuss@rocaille.de" className="legal__link">genuss@rocaille.de</a>
    </p>
    <p className="legal__text">
      Sie haben das Recht, eine erteilte Einwilligung jederzeit zu widerrufen sowie die Einschränkung
      der Verarbeitung zu verlangen. Im Falle von DSGVO-Verstößen steht Ihnen ein Beschwerderecht bei
      der zuständigen Aufsichtsbehörde zu. Diese Seite nutzt SSL/TLS-Verschlüsselung.
    </p>

    <h3 className="legal__subtitle">4. Datenerfassung auf dieser Website</h3>
    <h4 className="legal__h4">Cookies</h4>
    <p className="legal__text">
      Unsere Website verwendet Cookies. Technisch notwendige Cookies sind zur Gewährleistung des
      ordnungsgemäßen Betriebs erforderlich (Art. 6 Abs. 1 lit. f DSGVO). Optionale Cookies für
      Analyse- und Marketingzwecke werden nur nach Ihrer ausdrücklichen Einwilligung gesetzt
      (Art. 6 Abs. 1 lit. a DSGVO).
    </p>

    <h4 className="legal__h4">Kontaktformular</h4>
    <p className="legal__text">
      Anfragen über das Kontaktformular werden inklusive Ihrer Kontaktdaten zur Bearbeitung gespeichert.
      Rechtsgrundlage: Art. 6 Abs. 1 lit. b oder lit. f DSGVO. Die Daten werden gelöscht, sobald der
      Zweck entfällt.
    </p>

    <h3 className="legal__subtitle">5. Analyse-Tools und Marketing</h3>
    <h4 className="legal__h4">Vercel Analytics</h4>
    <p className="legal__text">
      Diese Website nutzt Vercel Analytics, einen Webanalysedienst der Vercel Inc., 440 N Barranca
      Ave #4133, Covina, CA 91723, USA. Vercel Analytics erfasst anonymisierte Nutzungsdaten
      (z. B. Seitenaufrufe, Herkunftsland) ohne Verwendung von Cookies und ohne persönliche
      Identifizierung einzelner Nutzer. Die Nutzung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
      DSGVO (berechtigtes Interesse an der Verbesserung unseres Angebots). Details:{' '}
      <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="legal__link">
        vercel.com/legal/privacy-policy
      </a>
    </p>

    <h3 className="legal__subtitle">6. Soziale Medien</h3>
    <h4 className="legal__h4">Facebook und Instagram (Meta Platforms)</h4>
    <p className="legal__text">
      Anbieter: Meta Platforms Ireland Limited, Dublin 2, Irland. Die Nutzung erfolgt auf Grundlage
      Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).{' '}
      <a href="https://www.facebook.com/about/privacy/" target="_blank" rel="noopener noreferrer" className="legal__link">
        Datenschutzerklärung Meta
      </a>
    </p>

    <h3 className="legal__subtitle">7. Plugins und Tools</h3>
    <h4 className="legal__h4">Google Fonts</h4>
    <p className="legal__text">
      Diese Seite nutzt Google Fonts (Google Ireland Limited). Nutzung auf Grundlage Ihrer Einwilligung
      (Art. 6 Abs. 1 lit. a DSGVO).{' '}
      <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="legal__link">
        Datenschutzerklärung Google
      </a>
    </p>

    <h4 className="legal__h4">Google Maps</h4>
    <p className="legal__text">
      Diese Seite nutzt Google Maps (Google Ireland Limited). Die Nutzung erfordert die Speicherung
      Ihrer IP-Adresse. Nutzung auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).{' '}
      <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer" className="legal__link">
        Datenschutzerklärung Google
      </a>
    </p>
  </>
);

function LegalModal({ type, onClose }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div className="legal-modal__backdrop" onClick={onClose}>
      <div className="legal-modal__panel" onClick={(e) => e.stopPropagation()}>
        <button className="legal-modal__close" onClick={onClose} aria-label="Schließen">✕</button>
        <h2 className="legal-modal__title">
          {type === 'impressum' ? 'Impressum' : 'Datenschutzerklärung'}
        </h2>
        <div className="legal-modal__divider" />
        <div className="legal-modal__content">
          {type === 'impressum' ? impressumContent : datenschutzContent}
        </div>
      </div>
    </div>
  );
}

export default LegalModal;
